import { helper } from '@ember/component/helper';

const IMAGE_EXTENSIONS = new Set(['png', 'jpeg', 'jpg', 'gif', 'webp', 'svg']);

/**
 * Verifica se il nome file è un'immagine
 */
var isImage = helper(function isImage([name]) {
  if (typeof name !== 'string') return false;
  const lowerName = name.toLowerCase();
  // Controlla se è esattamente un'estensione o se finisce con .estensione
  if (IMAGE_EXTENSIONS.has(lowerName)) return true;
  const ext = lowerName.split('.').pop();
  return IMAGE_EXTENSIONS.has(ext);
});

export { isImage as default };
//# sourceMappingURL=is-image.js.map
